module.exports = "/foodslaboEf/img/step1/Subtract.svg";